// choices/vibeChoices.js
const vibeChoicesBg = [
  {
    label: "Спокойствие",
    value: "calm",
  },
  {
    label: "Активност",
    value: "active",
  },
  {
    label: "Комфорт",
    value: "comfortable",
  },
  {
    label: "Елегантност",
    value: "elegant",
  },
  {
    label: "Креативност",
    value: "creative",
  },
];

export default vibeChoicesBg;
